import React, { useState, useContext } from 'react'
import './home.css'
import Navigation from '../../components/navigation/Navigation'
import Carousel from '../../components/carousel/Carousel'
import Test from '../../components/textComponets/Test'
import ProductCard from '../../components/product-card/ProductCard'
import { Col, Row } from 'react-bootstrap'
import productList from '../../assets/data/productList.json'
import Footer from '../../components/footer/Footer'
import { ProductContext } from '../../contexts/ProductContext'
import { Link } from 'react-router-dom'

function Home() {
    const { products } = useContext(ProductContext);
    
    const [navBackground, setNavBackground] = useState('transparent');
    const [navIcon, setNavIcon] = useState('https://res.cloudinary.com/emacon-production/image/upload/v1648793433/the-outlet/THE_OUTLET_PNG_t6abcu.png')

    const changeNavigationBackground = () => {
        if(window.scrollY >= 80) {
            setNavBackground('theme-color');
            setNavIcon('https://res.cloudinary.com/emacon-production/image/upload/v1654424700/the-outlet/2_cx772d.png')
        } else {
            setNavBackground('transparent')
            setNavIcon('https://res.cloudinary.com/emacon-production/image/upload/v1648793433/the-outlet/THE_OUTLET_PNG_t6abcu.png')
        }
    }

    window.addEventListener('scroll', changeNavigationBackground);

    return (
        <div className='home'>
            <Navigation background={navBackground} logo={navIcon}/>
            <Carousel type="hero" />
            <Row className="section-2">
                <Col md={2} xs={12} className="adBanner">
                   <div onClick={() => window.location.href = "https://theoutletvendor.netlify.app/" } ></div>
                </Col>
                <Col md={10} sm={12}>
                    <Row className="productList">
                        {
                            products.data &&
                            products.data.map((item, index) => (
                                <React.Fragment key={index}>
                                    {
                                        index <= 7 ? (
                                            <Col xl={3} lg={3} md={4} sm={6} xs={6} >
                                                <ProductCard
                                                    product={item}
                                                />
                                            </Col>
                                        ) : null
                                    }
                                </React.Fragment>
                                
                                
                            ))
                        } 
                    </Row>

                    
                </Col>
            </Row>

            <div className='mid_banner'>
                <Carousel type="banner" />
            </div>

            <Row className="section-2">
                <Col md={10}>
                    <Row className="productList">
                        {
                            products.data &&
                            products.data.map((item, index) => (
                                <React.Fragment key={index}>
                                    {
                                        index >= 8 && index <= 15 ? (
                                            <Col xl={3} lg={3} md={4} sm={6} xs={6}  className="product_column">
                                                <ProductCard
                                                    product={item}
                                                    
                                                />
                                            </Col>
                                        ) : null
                                    }
                                </React.Fragment>
                                
                                
                            ))
                        } 
                    </Row>

                    
                </Col>
                <Col md={2} className="adBanner2">
                    <div onClick={() => window.location.href = "https://theoutletvendor.netlify.app/" } ></div>
                </Col>
            </Row>

            {
                products.data &&
                products.data.length > 15 && products.data.length >= 23 ? (
                    <Row className="section-2">
                        <Col md={2} xs={12} className="adBanner3">
                        <div></div>
                        </Col>
                        <Col md={10} sm={12}>
                            <Row className="productList">
                                {
                                    products.data &&
                                    products.data.map((item, index) => (
                                        <React.Fragment key={index}>
                                            {
                                                index >= 16 && index <= 23 ? (
                                                    <Col xl={3} lg={3} md={4} sm={6} xs={6} >
                                                        <ProductCard
                                                            product={item}
                                                        />
                                                    </Col>
                                                ) : null
                                            }
                                        </React.Fragment>
                                        
                                        
                                    ))
                                } 
                            </Row>

                            
                        </Col>
                    </Row>
                ) : null
            }

            {
                products.data &&
                products.data.length > 23 && products.data.length >= 31 ? (
                    <React.Fragment>
                        <div className='mid_banner'>
                            <Carousel type="banner" />
                        </div>

                        <Row className="section-2">
                            <Col md={10}>
                                <Row className="productList">
                                    {
                                        products.data &&
                                        products.data.map((item, index) => (
                                            <React.Fragment key={index}>
                                                {
                                                    index >= 24 && index <= 31 ? (
                                                        <Col xl={3} lg={3} md={4} sm={6} xs={6}  className="product_column">
                                                            <ProductCard
                                                                product={item}
                                                                
                                                            />
                                                        </Col>
                                                    ) : null
                                                }
                                            </React.Fragment>
                                            
                                            
                                        ))
                                    } 
                                </Row>

                                
                            </Col>
                            <Col md={2} className="adBanner4">
                                <div onClick={() => window.location.href = "https://theoutletvendor.netlify.app/" } ></div>
                            </Col>
                        </Row>
                    </React.Fragment>
                    
                ) : null
            }

            {
                products.data &&
                products.data.length > 23 && products.data.length >= 31 ? (
                    <Row className="section-2">
                        <Col md={2} xs={12} className="adBanne5">
                        <div></div>
                        </Col>
                        <Col md={10} sm={12}>
                            <Row className="productList">
                                {
                                    products.data &&
                                    products.data.map((item, index) => (
                                        <React.Fragment key={index}>
                                            {
                                                index >= 24 && index <= 31 ? (
                                                    <Col xl={3} lg={3} md={4} sm={6} xs={6} >
                                                        <ProductCard
                                                            product={item}
                                                        />
                                                    </Col>
                                                ) : null
                                            }
                                        </React.Fragment>
                                        
                                        
                                    ))
                                } 
                            </Row>

                            
                        </Col>
                    </Row>
                ) : null
            }

            {
                products.data &&
                products.data.length > 31 && products.data.length >= 39 ? (
                    <React.Fragment>
                        <div className='mid_banner'>
                            <Carousel type="banner" />
                        </div>

                        <Row className="section-2">
                            <Col md={10}>
                                <Row className="productList">
                                    {
                                        products.data &&
                                        products.data.map((item, index) => (
                                            <React.Fragment key={index}>
                                                {
                                                    index >= 32 && index <= 39 ? (
                                                        <Col xl={3} lg={3} md={4} sm={6} xs={6}  className="product_column">
                                                            <ProductCard
                                                                product={item}
                                                                
                                                            />
                                                        </Col>
                                                    ) : null
                                                }
                                            </React.Fragment>
                                            
                                            
                                        ))
                                    } 
                                </Row>

                                
                            </Col>
                            <Col md={2} className="adBanner6">
                                <div onClick={() => window.location.href = "https://theoutletvendor.netlify.app/" } ></div>
                            </Col>
                        </Row>
                    </React.Fragment>
                    
                ) : null
            }

            
            
            <Footer/>
        </div>
    )
}

export default Home
